import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { Option } from "../../../types/General/Option";

interface OrganizationSelectComponent {
  fieldNameObject: string;
  options: Option[];
  fieldName: string;
  width: string;
  control: any;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  isDisabled?: boolean;
  isLoaded: boolean;
}

export const organizationSelectFilterData = (
  provinceOptions: Option[],
  countyOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedProvince: Dispatch<SetStateAction<Option | null>>,
  setSelectedCounty: Dispatch<SetStateAction<string | null>>,
  selectedProvince: Option | null,
  provinceLoaded: boolean,
  countyLoaded: boolean,
): OrganizationSelectComponent[] => {
  const handleProvinceChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedProvinceId = e.target.value;
    const selected = provinceOptions.find(
      (p) => p.id.toString() === selectedProvinceId,
    );
    setSelectedProvince(selected || null);
    setFilter("ProvinceId", selectedProvinceId);
  };

  const handleCountyChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedCountyId = e.target.value;
    setSelectedCounty(e.target.selectedOptions[0].text);
    setFilter("CountyId", selectedCountyId);
  };

  return [
    {
      fieldNameObject: "ProvinceId",
      options: provinceOptions,
      fieldName: "Província",
      width: "230px",
      control: control,
      onChange: handleProvinceChange,
      isLoaded: provinceLoaded,
    },
    {
      fieldNameObject: "CountyId",
      options: countyOptions,
      fieldName: "Município",
      width: "230px",
      control: control,
      onChange: handleCountyChange,
      isDisabled: !selectedProvince || selectedProvince.name === "",
      isLoaded: countyLoaded,
    },
  ];
};
